import { ScrollDemoPlayer } from "./ScrollDemoPlayer";

export function HeroSection() {
  return (
    <div className="relative bg-gradient-to-b from-[#f4f7ff] via-white to-white">
      <section className="relative flex min-h-[calc(100vh-64px)] flex-col items-center justify-center px-6 py-20 text-center">
        <div className="pointer-events-none absolute inset-0">
          <div className="dotgrid absolute -left-10 top-24 h-40 w-40 opacity-60" />
          <div className="dotgrid absolute bottom-28 right-6 h-40 w-40 opacity-60" />
          <div className="absolute left-1/2 top-20 h-64 w-64 -translate-x-1/2 rounded-full bg-brand-100/60 blur-[100px]" />
          <div className="absolute bottom-0 left-1/2 h-64 w-[min(980px,90vw)] -translate-x-1/2 rounded-[100%] bg-brand-100/60 blur-[90px]" />
          <svg
            aria-hidden="true"
            className="absolute bottom-[-64px] left-1/2 h-[240px] w-[min(980px,90vw)] -translate-x-1/2 text-brand-300/50"
            fill="none"
            viewBox="0 0 980 280"
          >
            <path
              d="M24 256C142 164 246 120 368 128c89 6 120 55 210 55 108 0 139-85 242-117 55-18 99-20 136-17"
              stroke="currentColor"
              strokeDasharray="10 14"
              strokeLinecap="round"
              strokeWidth="2"
            />
          </svg>
        </div>

        <div className="relative z-10 mx-auto max-w-[940px]">
          <span className="inline-flex items-center gap-2 rounded-full border border-brand-200 bg-white/70 px-5 py-2.5 text-[15px] font-bold leading-relaxed text-brand-700 md:text-[16px]">
            <span className="h-1.5 w-1.5 rounded-full bg-brand-500" />
            <span>
              <span className="whitespace-nowrap">1.1万円/月で500通まで、</span>
              <br className="md:hidden" />
              <span className="whitespace-nowrap">担当者1人でもスカウトを負担なく</span>
            </span>
          </span>
          <h1 className="mt-6 text-[56px] font-black leading-[1.05] tracking-tight md:text-[80px]">
            <span className="whitespace-nowrap">スカウト業務を</span>
            <br />
            <span className="whitespace-nowrap">ひとりで回せる</span>
          </h1>
          <p className="mx-auto mt-6 max-w-[720px] text-[16px] leading-[1.9] text-ink-600 md:text-[18px]">
            自社ページ分析から文面生成、送信管理、レポート機能、効果測定まで。
            <br />
            スカウト業務の流れを、ひとつの仕組みにまとめます。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <a
              className="btn-primary inline-flex h-12 items-center gap-2 rounded-lg px-5 font-semibold text-white"
              href="#cta"
            >
              <img alt="Chrome" className="h-5 w-5" src="/images/lp/chrome-icon.png" />
              Chrome拡張機能をインストール
            </a>
            <a
              className="inline-flex h-12 items-center gap-2 rounded-lg border border-ink-200 bg-white px-5 font-semibold text-ink-800 hover:bg-ink-50"
              href="#cta"
            >
              <span className="mi text-[18px] text-ink-500">play_circle</span>
              デモを申し込む
            </a>
          </div>
          <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-[12px] text-ink-500">
            <li className="flex items-center gap-1.5">
              <span className="mi text-[16px] text-ink-400">extension</span>Chrome拡張で利用
            </li>
            <li className="flex items-center gap-1.5">
              <span className="mi text-[16px] text-ink-400">web</span>
              全てのスカウトサイトで利用可能
            </li>
            <li className="flex items-center gap-1.5">
              <span className="mi text-[16px] text-ink-400">table_view</span>作業データをCSV出力
            </li>
          </ul>
        </div>
      </section>
      <ScrollDemoPlayer />
    </div>
  );
}
